module.exports = __webpack_public_path__ + "static/seo-appetini-906084b1837cbec7c0caa2f03134e3b6.png";